export type UserRole =
  | 'SYSTEM_ADMIN'
  | 'DEVELOPER'
  | 'TREASURER'
  | 'PASTOR'
  | 'INVENTORY'
  | 'EXPENSES'

export enum UserRoleEnum {
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  DEVELOPER = 'DEVELOPER',
  TREASURER = 'TREASURER',
  PASTOR = 'PASTOR',
  INVENTORY = 'INVENTORY',
  EXPENSES = 'EXPENSES',
}

export enum UserRoleDisplayName {
  SYSTEM_ADMIN = 'System Admin',
  DEVELOPER = 'Developer',
  TREASURER = 'Treasurer',
  PASTOR = 'Pastor',
  INVENTORY = 'Inventory Manager',
  EXPENSES = 'Expenses Manager',
}

export type UserCreateInput = {
  email: string
  name: string
  roles: Array<UserRole>
  churchId?: Array<string>
  isAdminPastor?: boolean
}

export type UserUpdateInput = UserCreateInput & {
  _id: string
  active: boolean
}

type UserResponse = UserUpdateInput & {
  isVerified?: boolean
  isTemporaryPassword?: boolean
  createdAt?: string
  updatedAt?: string
  expireAt?: Date
}

export type User = UserResponse
